import React from "react";

const VisionMission = () => {
  return (
    <div className="vm-section p-0">
      <div className="container">

        <h2 className="vm-title text-dark ">Shivai Travels - Vision & Mission</h2>

        <div className="vm-grid p-0">

          {/* Vision */}
          <div className="vm-card vision ">
            <div className="vm-icon-box">👁️</div>
            <h3>Our Vision</h3>
            <p>
              At Shivai Travels, our vision is to become a leading and most trusted travel partner, known for delivering safe, comfortable, and reliable journeys. We aim to simplify travel by combining modern technology with personalized service, making every trip smooth and enjoyable.

              We envision expanding our services across regions while maintaining high standards of quality, customer satisfaction, and innovation in the travel industry.
            </p>
          </div>

          {/* Mission */}
          <div className="vm-card mission">
            <div className="vm-icon-box">🎯</div>
            <h3>Our Mission</h3>
            <p>
              Our mission at Shivai Travels is to provide dependable, affordable, and customer-focused transportation services. We are committed to ensuring safety, punctuality, and comfort through well-maintained vehicles and experienced drivers.

              We strive to exceed customer expectations by offering transparent pricing, responsive support, and continuously improving our services based on customer needs and feedback.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default VisionMission;